import { Typography } from '@mui/material';

type SelectedRowsCountProps = {
  count: number;
};

/** Shared “N selected” label for desktop selection chrome (matches mobile copy). */
export const SelectedRowsCount = ({ count }: SelectedRowsCountProps) => {
  if (count <= 0) {
    return null;
  }

  return (
    <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'nowrap', flexShrink: 0, fontWeight: 700 }}>
      {`נבחרו ${count}`}
    </Typography>
  );
};
